/**
 * Genetic addon test IDs mapping
 * These tests have two versions: blood and saliva
 */
export const BLOOD_SALIVA_ADDON_IDS = {
  'ApoE': { blood: 861, saliva: 862 },
  'MTHFR': { blood: 863, saliva: 864 },
  'FACTOR_II_V': { blood: 865, saliva: 866 }
};
